module.exports = __webpack_public_path__ + "images/stickers/heart.ccb4d362efc7dc250d10.png";